<div class="col pl-0 pr-0 loyalty-banner-container">
<section class="loyalty-main">
    <div class="loyalty-banner-container" [ngClass]="{'rewards-tw': showCompany==='tw', 'rewards-acic': showCompany==='acic'}">
        <div class="loyalty-content">
            <img src="./assets/img/images/loyalty-banner-icon.svg" alt="loyalty banner icon" />
            <div class="header-with-button w-100-mobile">
                <div>
                    <p class="loyalty-title dm-sans-medium">My Mapfre Rewards</p>
                    <p class="loyalty-txt">
                        Exclusive perks to save you money and simplify your life.
                    </p>
                </div>
                <a (click)="goToLearnMore()"
                    class="loyaltyBtn mapfre btn ghost primary"> Learn more </a>
            </div>
        </div>
    </div>
</section>
</div>